module.exports = __webpack_public_path__ + "static/media/order.4f55f667.svg";